import createPersistedReducer from '@/redux/lib/createPersistedReducer.js';

const initialState = {
  introChat: {
    messages: [
      {
        id: 'intro-ai-1',
        role: 'assistant',
        content: 'Welcome to Pieve. What should I call you?'
      }
    ],
    name: '',
    job: '',
    jobFamily: null,
    isDevRole: null,
    shouldSkipOnboarding: false
  }
};

export default createPersistedReducer(
  initialState,
  {
    onboardingAppendIntroChatMessage: (state, payload) => {
      const message = payload && typeof payload === 'object' ? payload : null;
      const normalizedMessageId = String(message?.id || '').trim();
      const normalizedRole = String(message?.role || '').trim();
      const normalizedContent = String(message?.content || '').trim();

      if (!normalizedMessageId || !normalizedRole || !normalizedContent) {
        return state;
      }

      const existingMessages = Array.isArray(state?.introChat?.messages) ? state.introChat.messages : [];

      if (
        existingMessages.some((existingMessage) => {
          return String(existingMessage?.id || '').trim() === normalizedMessageId;
        })
      ) {
        return state;
      }

      return {
        ...state,
        introChat: {
          ...state.introChat,
          messages: existingMessages.concat([
            {
              id: normalizedMessageId,
              role: normalizedRole,
              content: normalizedContent
            }
          ])
        }
      };
    },

    onboardingApplyIntroChatResponse: (state, payload) => {
      const assistantMessage = payload?.message && typeof payload.message === 'object' ? payload.message : null;
      const assistantMessageId = String(assistantMessage?.id || '').trim();
      const assistantMessageContent = String(assistantMessage?.content || '').trim();
      const existingMessages = Array.isArray(state?.introChat?.messages) ? state.introChat.messages : [];
      const nextMessages =
        assistantMessageId && assistantMessageContent
          ? existingMessages.concat([
              {
                id: assistantMessageId,
                role: 'assistant',
                content: assistantMessageContent
              }
            ])
          : existingMessages;

      return {
        ...state,
        introChat: {
          ...state.introChat,
          messages: nextMessages,
          name: String(payload?.name || '').trim(),
          job: String(payload?.job || '').trim(),
          jobFamily: payload?.jobFamily || null,
          isDevRole: typeof payload?.isDevRole === 'boolean' ? payload.isDevRole : null,
          shouldSkipOnboarding: payload?.shouldSkipOnboarding === true
        }
      };
    },

    onboardingResetIntroChat: () => {
      return initialState;
    }
  },
  {
    key: 'onboarding-session'
  }
);
